// Auth
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN'
export const SET_IP_ADDRESS = 'SET_IP_ADDRESS'
export const SET_CAPTCHA_CODE = 'SET_CAPTCHA_CODE'
export const SET_MESSAGE = 'SET_MESSAGE'
export const SET_LOGOUT = 'SET_LOGOUT'


// App
export const SET_APP_LANGUAGE = 'SET_APP_LANGUAGE'
export const SET_OFFERS = 'SET_OFFERS'

// User
export const SET_MAPPED_CUSTOMER_ID = 'SET_MAPPED_CUSTOMER_ID'
export const SET_USERNAME = 'SET_USERNAME'
export const SET_USER_PROFILE = 'SET_USER_PROFILE'
export const SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE'
export const SET_LAST_LOGIN_TIME = 'SET_LAST_LOGIN_TIME'

// Accounts
export const SET_CURRENT = 'SET_CURRENT'
export const SET_ACCOUNTS = 'SET_ACCOUNTS'
export const SET_ACCOUNT_DETAIL = 'SET_ACCOUNT_DETAIL'
export const SET_SELECTED_BENE_DETAIL = 'SET_SELECTED_BENE_DETAIL'


// Deposits
export const SET_ACC_CLASS = 'SET_ACC_CLASS'

// Reset All
export const RESET_ACCOUNTS = 'RESET_ALL_ACCOUNTS'
export const RESET_USER = 'RESET_USER'
export const RESET_CAROUSEL = 'RESET_CAROUSEL'
export const RESET_AUTH = 'RESET_AUTH'
export const RESET_APP = 'RESET_APP'

// Carousel
export const SET_CURRENT_ITEM = 'SET_CURRENT_ITEM'
export const SET_ITEMS = 'SET_ITEMS'
export const SET_CURRENT_ITEM_DETAIL = 'SET_CURRENT_ITEM_DETAIL'
export const SET_REMARKS = 'SET_REMARKS'
export const SET_LOAN_ACCOUNT_DETAILS= 'SET_LOAN_ACCOUNT_DETAILS'
export const SET_DEPOSIT_ACCOUNT_DETAILS = 'SET_DEPOSIT_ACCOUNT_DETAILS'
export const SET_ACCOUNT_REFRESH = 'SET_ACCOUNT_REFRESH'



export const SET_STYLES = 'SET_STYLES'
export const STYLES_URL = 'https://localhost/styles'

export const expiryMonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
export const expiryYear = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '37',
  '38',
  '39',
  '40',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '50',
  '51',
  '52',
  '53',
  '54',
  '55',
  '56',
  '57',
  '58',
  '59',
  '60',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '68',
  '69',
  '70',
  '71',
  '72',
  '73',
  '74',
  '75',
  '76',
  '77',
  '78',
  '79',
  '80',
  '81',
  '82',
  '83',
  '84',
  '85',
  '86',
  '87',
  '88',
  '89',
  '90',
  '91',
  '92',
  '93',
  '94',
  '95',
  '96',
  '97',
  '98',
  '99',
]
